import { Avatar, Button, Card, Checkbox, Divider, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ReactComponent as NoAccountFound } from "../../../../../Assets/noAccounts.svg";
import { translation } from "../../../../../i18n/translationConstant";
import LinkedDelinkedAccountResponse from "../../../../../Models/Response/Account/LinkedDelinkedAccounts";
import { QueryParams, Routes } from "../../../../../Utils/Constants/routes";
import "../index.css";

interface IPendingConsentProps {
  cardClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  selectedCard: string[];
  approvalConsent: (type: string) => void;
  linkedAccounts: LinkedDelinkedAccountResponse;
}

const PendingConsent: React.FC<IPendingConsentProps> = ({
  cardClick,
  selectedCard,
  approvalConsent,
  linkedAccounts,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [linkAccountsToShow, setLinkedAccountsToShow] =
    useState<LinkedDelinkedAccountResponse>([]);

  const [isViewAll, setViewAll] = useState(false);


  useEffect(() => {
    setLinkedAccountsToShow(linkedAccounts.slice(0, 2));
  }, [linkedAccounts]);

  const viewAll = () => {
    if (isViewAll) {
      setLinkedAccountsToShow(linkedAccounts.slice(0, 2));
    } else {
      setLinkedAccountsToShow(linkedAccounts);
    }
    setViewAll(!isViewAll);
  };

  const linkAccountsRedirect = () => {
    history.push({
      pathname: Routes.linkAccounts,
      search: `?${QueryParams.redirect}=${history.location.pathname}`,
    });
  };

  const secondaryButtonClick = () => {
    approvalConsent(
      // localStorage.getItem("isV1") === "true" ? "FAILED" : "REJECTED" 
      "FAILED"
    );
  };

  const primaryButtonClick = () => {
    approvalConsent(
      // localStorage.getItem("isV1") === "true" ? 
      "READY" 
      // : "APPROVED" 
    );
  };

  const { Text } = Typography;
  return (
    <>
      <div className="consentDetailsSubRoot">
        {linkAccountsToShow && linkAccountsToShow.length ? (
          <div className="consentDetailsAccounts">
            {linkAccountsToShow.map((accounts, index) => (
              <Card
                key={index}
                className="accountCard"
                id={index.toString()}
                hoverable={false}
                onClick={cardClick}
              >
                <Avatar className="consentAvatar" src={accounts.logoUrl} />
                <div className="accountInfo">
                  <Text className="accountCardFIP">{accounts.fipName}</Text>
                  <br />
                  <div>
                    <Text className="accountCardNumber">
                      {accounts.maskedAccNumber}
                    </Text>
                  </div>
                  <Text className="accountCardAccountType">
                    {accounts.accountType}
                  </Text>
                  <Divider type="vertical" />
                  <Text className="accountCardAccountType">
                    {accounts.fiType}
                  </Text>
                </div>

                <Checkbox
                  checked={
                    selectedCard.indexOf(index.toString()) === -1 ? false : true
                  }
                  className="accountsCardCheckBox"
                />
              </Card>
            ))}
          </div>
        ) : (
          <Card className="noAccountEmpty">
            <div className="actionDiv">
              <Typography.Text className="noAccountText">
                {t(translation.errorNoBanksFound)}
              </Typography.Text>{" "}
              <Button
                className="commonButtonBackground primaryButton linkAccountNoAccounts"
                onClick={linkAccountsRedirect}
              >
                {t(translation.lblLinkAccount)}
              </Button>
            </div>
            <div className="noAccountImageDiv">
              <NoAccountFound className="noAccountSVG" />
            </div>
          </Card>
        )}
        <div className="activeButtonGroup">
          <Button
            className="commonButtonBackground secondaryButton width40Pmargintop0"
            onClick={secondaryButtonClick}
          >
            {t(translation.lblReject)}
          </Button>
          {linkedAccounts && linkedAccounts.length ? (
            <Button
              disabled={selectedCard.length === 0}
              className="commonButtonBackground primaryButton linkAccountNoAccounts primaryButtonWidth"
              onClick={primaryButtonClick}
            >
              {t(translation.lblAccept)}
            </Button>
          ) : (
            <></>
          )}
        </div>
      </div>
      {linkedAccounts && linkedAccounts.length > 2 ? (
        <Button className="viewAllButton" type="text" onClick={viewAll}>
          {isViewAll ? "View less" : "View all"}
        </Button>
      ) : (
        <></>
      )}
    </>
  );
};

export default PendingConsent;
